import Component from '@glimmer/component';

interface UiInputGroupDescriptionSignature {
  Element: HTMLParagraphElement;
  Args: {
    Named: {
      id: string;
      showError?: boolean;
      errorMessage?: string;
      wrap?: boolean;
    };
  };
  Blocks: {
    default: [];
  };
}

export default class UiInputGroupDescriptionComponent extends Component<UiInputGroupDescriptionSignature> {}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::InputGroup::Description': typeof UiInputGroupDescriptionComponent;
    'ui/input-group/description': typeof UiInputGroupDescriptionComponent;
  }
}
